export default "__VITE_ASSET__ChgEZ_0Y__"